<template>
  <v-row
    align-center
    justify-center
    row
    dense
  >
    <v-col
      class="px-0"
      cols="12"
    >
      <v-autocomplete
        v-model="user"
        dense
        :error-messages="errorForField()"
        :items="users"
        :loading="loading"
        :search-input.sync="search"
        item-text="name"
        placeholder="Search by name, number or email"
        hide-no-data
        hide-selected
        no-filter
        outlined
        return-object
        clearable
        @click:clear="resetSearch"
        @input="handleSelected"
      />
    </v-col>
  </v-row>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "ExistingUserV2",
  model: {
    prop: "useExistingUser",
    event: "input",
  },
  props: {
    errors: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    useExistingUser: { type: Boolean, default: false },
  },
  data: function () {
    return {
      user: {},
      loading: false,
      users: [],
      search: null,
    };
  },
  watch: {
    search(query) {
      this.resetError();

      if (query == null) return;
      if (query.length <= 2) return;
      if (this.loading) return;

      this.loading = true;
      let self = this;
      let url = `${this.$store.state.apiUrl}/customer/search?query=${query}`;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          self.users = res.data.customers;
          self.loading = false;
        })
        .catch(function (err) {
          console.error(err);
          self.loading = false;
        });
    },
    useExistingUser() {
      if (this.useExistingUser == false) {
        // this.user = {};
      }
      this.$emit("useExistingUserToggled", this.useExistingUser);
    },
  },
  methods: {
    handleSelected: function () {
      this.$emit("selectedUser", this.user);
    },
    errorForField: function () {
      try {
        return this.errors["use_existing"];
      } catch (err) {
        return null;
      }
    },
    resetError: function () {
      try {
        if (this.errors["use_existing"] != "") {
          this.errors["use_existing"] = "";
        }
      } catch (err) {}
    },
    resetSearch: function () {
      this.users = [];
      this.search = null;
    },
  },
};
</script>